import React from 'react';
import cn from 'classnames';
import Icon from './spinner.svg';
import styles from './styles.css';

const Spinner = ({ className, ...props }) => {
  // Hack for SVG loader not being available in the test environment
  if (process.env.NODE_ENV === 'test') {
    return <span />;
  }

  return <Icon className={cn('spin', styles.container, className)} {...props} />;
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/spinner/spinner.jsx